import React from "react";
import { useSelector } from "react-redux";
import { Button, ButtonGroup } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { getSelectedTimePeriodText, getTimePeriods } from "../../../../store/ui/conversion";
import { updateSelectedTimePeriod } from "../../../../components/common/StoreCommon";

const PERIOD_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Week", value: "This Week" },
  { label: "Month", value: "This Month" },
];

export default function TimePeriodSelector() {
  const classes = useStyles();
  const timePeriods = useSelector((state) => getTimePeriods(state.ui.conversion));
  const selectedPeriodText = useSelector((state) =>
    getSelectedTimePeriodText(state.ui.conversion)
  );

  const availableOptions = PERIOD_OPTIONS.filter((option) =>
    timePeriods.includes(option.value)
  );

  if (availableOptions.length === 0) {
    return null;
  }

  return (
    <ButtonGroup
      size="small"
      className={classes.viewToggle}
      aria-label="Time period"
    >
      {availableOptions.map((option) => (
        <Button
          key={option.value}
          className={
            selectedPeriodText === option.value
              ? `${classes.toggleButton} ${classes.toggleButtonSelected}`
              : classes.toggleButton
          }
          onClick={() => updateSelectedTimePeriod(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
}

const useStyles = makeStyles((theme) => ({
  viewToggle: {
    boxShadow: "none",
    width: "auto",
  },
  toggleButton: {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "16px",
    padding: theme.spacing(0.5, 1.25),
    minWidth: 0,
    color: "rgb(135, 131, 131)",
    borderColor: "rgb(185, 181, 181)",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  toggleButtonSelected: {
    color: theme.palette.primary.main,
    backgroundColor: "rgba(25, 118, 210, 0.08)",
    borderColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.12)",
    },
  },
}));
